export default "__VITE_ASSET__20e184ba__"